import React, { useState, useRef, useEffect } from "react";
import axios from 'axios';
import { useNavigate, useLocation } from "react-router-dom";

function AddManager(props) {

    const navigate = useNavigate();
    const location = useLocation();
    const [loginId, setLoginId] = useState(0);
    const [loginName, setLoginName] = useState(0);

    useEffect(() => {
        setLoginId(location.state.id);
        setLoginName(location.state.loginName);
        console.log(location.state.id, '/', location.state.name);
    }, [location.state]);

    const addManagerStart = async () => {
        const id = document.getElementById('id').value;
        const pw = document.getElementById('pw').value;
        const name = document.getElementById('name').value;
        const phone_num = document.getElementById('phone_num').value;
        const account_kind = document.getElementById('account_kind').value;
        const account_num = document.getElementById('account_num').value;

        try {
            console.log(id + "/" + pw + "/" + name + "/" + phone_num + "/" + account_kind + "/" + account_num);
            const result = await axios.post('/ManagerRegist', { id, pw, name, phone_num, account_kind, account_num });
            console.log(result.data);
            alert(result.data.message);
            navigate('/manager')
        } catch (error) {
            console.error('Error adding manager:', error.message);
            // Handle error
        }
    }

    return (
        <div>
            <h2 style={{ textAlign: 'center', marginTop: '150px', fontSize: '30px' }}>매니저 등록</h2>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px', border: '1px solid #ddd', padding: '30px', borderRadius: '5px', marginLeft: '40%', marginRight: '40%' }}>
                <div style={{ marginBottom: '10px' }}>
                    <div style={{ marginRight: '10px' }}>아이디</div>
                    <input id="id" style={{ width: '100%', marginTop: '10px' }}></input>
                </div>
                <div style={{ marginBottom: '10px' }}>
                    <div style={{ marginRight: '10px' }}>비밀번호</div>
                    <input id="pw" style={{ width: '100%', marginTop: '10px' }}></input>
                </div>
                <div style={{ marginBottom: '10px' }}>
                    <div style={{ marginRight: '10px' }}>이름</div>
                    <input id="name" style={{ width: '100%', marginTop: '10px' }}></input>
                </div>
                <div style={{ marginBottom: '10px' }}>
                    <div style={{ marginRight: '10px' }}>핸드폰번호</div>
                    <input id="phone_num" style={{ width: '100%', marginTop: '10px' }}></input>
                </div>
                <div style={{ marginBottom: '10px' }}>
                    <div style={{ marginRight: '10px' }}>입금은행명</div>
                    <input id="account_kind" style={{ width: '100%', marginTop: '10px' }}></input>
                </div>
                <div style={{ marginBottom: '10px' }}>
                    <div style={{ marginRight: '10px' }}>계좌번호</div>
                    <input id="account_num" style={{ width: '100%', marginTop: '10px' }}></input>
                </div>
            </div>
            <div className="button-container">
                <button onClick={addManagerStart}>등록</button>
            </div>
        </div>
    )
}

export default AddManager;